import { Component, OnInit, Input, ViewChild, ElementRef, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { Chart } from 'chart.js'



export interface DataSetModel {
	label: any,
	backgroundColor?: string | string[],
	data: any,
	borderColor?: string | string[],
	fill?: boolean,
	showLine?: boolean,
	borderWidth?: number | number[]
}
export interface ScaleModel {
	scaleLabel?: {
		display: boolean,
		labelString: string
	},
	ticks?: {
		display?: boolean,
		beginAtZero?: boolean,
		precision?: number,
		steps?: number,
		stepValue?: number,
		max?: number,
		callback?: Function
	},
	gridLines?: {
		display?: boolean;
		tickMarkLength?: boolean;
		lineWidth?: number;
	}
}

export interface LineChartModel {
	labels: any[],
	datasets: DataSetModel[]
}
export interface LineOptionsModel {
	title?: {
		display: boolean,
		text: string,
		position?: string,
		fontColor?: string,
		fontSize?: number
	},
	maintainAspectRatio?: boolean,
	bezierCurve?: boolean,
	pointDotRadius?: number,
	scaleShowVerticalLines?: boolean,
	scaleShowHorizontalLines?: boolean,
	scaleGridLineColor?: string
	animation?: {
		duration?: number // general animation time
		onProgress?: Function,
		onComplete?: Function
	},
	responsiveAnimationDuration?: number,
	showTooltips?: boolean,
	disablePointerEvents?: boolean,
	hover?: {
		animationDuration: number // duration of animations when hovering an item
	},
	tooltips?: {
		callbacks?: {
			label?: Function
		},
		enabled: boolean;
	},
	layout?: {
		padding: {
			left: number,
			right: number,
			top: number,
			bottom: number
		}
	},
	responsive?: boolean,
	scales?: {
		yAxes?: ScaleModel[],
		xAxes?: ScaleModel[],
	},
	legend?: {
		display?: boolean,
		position?: string,
		labels?: {
			fontColor?: string,
			fontSize?: number
		}
	},
	elements?: {
		line?: {
			tension?: number
		},
		point?: {
			radius?: number
		}
	}
}

@Component({
	selector: 'app-line-chart',
	templateUrl: './line-chart.component.html',
	styleUrls: ['./line-chart.component.scss']
})
export class LineChartComponent implements OnInit {

	@Input() chartData: LineChartModel;
	@Input() chartOptions: LineOptionsModel;
	@ViewChild('lineChartEl') lineChartEl: ElementRef;
	lineChart;
	constructor(
		private renderer2: Renderer2,
		private cdref: ChangeDetectorRef
	) { }

	ngOnInit(): void {
	}

	ngOnChanges(changes) {
		this.cdref.detectChanges();
		if (changes.chartData && this.lineChartEl && changes.chartData.currentValue || changes.chartOptions && changes.chartOptions.currentValue) {
			let lineChartCanvas = this.lineChartEl.nativeElement;
			if (this.lineChart) {
				this.lineChart.destroy();
			}
			this.lineChart = new Chart(lineChartCanvas, {
				type: 'line',
				data: this.chartData,
				options: this.chartOptions
			});
			// lineChart.resize();
			// To disable pointer Events when scroll
			if (this.chartOptions.hasOwnProperty('disablePointerEvents')) {
				if (this.chartOptions.disablePointerEvents) {
					this.renderer2.setStyle(lineChartCanvas, 'pointer-events', 'none');
				}
			}


		}
	}

}
